import React, { useEffect, useState } from "react";
import { saveFileUseCase, saveImageUseCase } from "../../../usecases/file";
import { dialog } from "../../../nq-component";
import DialogWarning from "./DialogWarning";
import InputFactory from "../../../components/InputFactory";
import { footer } from "framer-motion/client";
import DialogSuccess from "./DialogSuccess";

const OrientationAgreement = ({ object, onSave }) => {
  const termsList = [
    "Purpose",
    "General Provisions",
    "Work Conditions",
    "Pay Days (Payroll Date)",
    "Employment Status",
    "Code of Discipline",
    "Company Benefits",
    "Deductions",
    "Schedule of final payment (13th Month Pay)",
    "Social Media",
    "Confidential Clause",
    "Grooming Standard",
    "Sexual Harassment Awareness",
    "Drug Free Workplace",
    "Smoke Free Workplace",
    "Workplace Policy & Program on Tuberculosis Prevention and Control",
    "Alcohol Free Workplace Policy and Program",
    "Workplace Policy and Program on Hepatitis B",
    "Employment Contract",
    "Company ID/LGS ID",
    "Hello Money/AUB",
    "Nameplate",
  ];

  const middleIndex = Math.ceil(termsList.length / 2);
  const leftTerms = termsList.slice(0, 12);
  const rightTerms = termsList.slice(12);

  const [checkedTerms, setCheckedTerms] = useState(
    Array(termsList.length).fill(false)
  );
  const [signature, setSignature] = useState(null);
  const [agreedStatus, setAgreedStatus] = useState(false);

  useEffect(() => {
    if (object) {
      setSignature(object.signature || null);
      setAgreedStatus(object.termsAgreed || false);
    }
  }, [object]);
  const handleCheck = (index) => {
    const updated = [...checkedTerms];
    updated[index] = !updated[index];
    setCheckedTerms(updated);
    console.log(checkedTerms);
  };

  const handleSignatureChange = (e) => {
    setSignature(e);
    console.log(e);
  };

  const handleSave = () => {
    const allChecked = checkedTerms.every((item) => item === true);
    if (allChecked) {
      // setAgreedStatus(true);
      onSave(true, signature);
    } else {
      dialog.fire({
        html: (
          <DialogWarning
            title={"Notice"}
            message={"Please agree to all the terms."}
          />
        ),
        footer: false,
      });
    }
  };

  const fullname = `${object?.firstName || ""} ${object?.middleName || ""} ${
    object?.lastName || ""
  }`;

  const today = new Date();

  const day = String(today.getDate()).padStart(2, "0");
  const month = today.toLocaleString("default", { month: "long" });
  const year = today.getFullYear();
  const effectivityDate = object?.updated
    ? new Date(object?.updated).toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      })
    : "Effectivity Date";
  const formattedDate = object?.orientationDate
    ? new Date(object.orientationDate)
        .toLocaleDateString("en-US", {
          year: "numeric",
          month: "long",
          day: "numeric",
        })
        .toUpperCase()
    : new Date()
        .toLocaleDateString("en-US", {
          year: "numeric",
          month: "long",
          day: "numeric",
        })
        .toUpperCase();

  return (
    <div className="p-4 px-md-5 bg-white border rounded shadow-sm d-flex flex-column">
      <img
        src="/lgsnobg.png"
        alt="LGS Logo"
        className="mb-3"
        style={{ maxWidth: "300px", alignSelf: "center" }}
      />
      <p className="mb-4 text-center fw-bold">
        ORIENTATION ACKNOWLEDGEMENT & ACCEPTANCE FORM
      </p>
      <div className="mt-3 d-flex flex-column gap-2">
        <p>
          I,
          <u className="mx-1">{fullname}</u>
          with permanent address at
          <u className="mx-1">
            {object?.permanent_houseNumber}, {object?.permanent_street},{" "}
            {object?.permanent_subdivision}, {object?.permanent_barangay},{" "}
            {object?.permanent_city}, {object?.permanent_province}
          </u>
          probationary employee of LGS STAFF MANAGEMENT SERVICES, INC. Effective
          on
          <u className="mx-1">{effectivityDate}</u>
        </p>
        <p>
          That I have accepted and confirm that I accept all the term and
          conditions stated in the COMPANY Rules and Regulations as listed below
          and it was fully explained to me by the officer of the COMPANY.
        </p>
      </div>
      <div className="d-flex flex-column flex-md-row mb-4">
        <div className="border border-1 border-black px-3 py-2 col-lg-6">
          {leftTerms.map((term, index) => (
            <div key={index} className="form-check mb-2">
              <input
                className="form-check-input cursor-pointer"
                type="checkbox"
                checked={object?.termsAgreed || checkedTerms[index]}
                onChange={() => handleCheck(index)}
                id={`term-${index}`}
              />
              <label
                className="form-check-label cursor-pointer"
                htmlFor={`term-${index}`}
              >
                {term}
              </label>
            </div>
          ))}
        </div>

        <div className="border border-1 border-black px-3 py-2 col-lg-6">
          {rightTerms.map((term, index) => (
            <div key={12 + index} className="form-check mb-2">
              <input
                className="form-check-input cursor-pointer"
                type="checkbox"
                checked={object?.termsAgreed || checkedTerms[12 + index]}
                onChange={() => handleCheck(12 + index)}
                id={`term-${12 + index}`}
              />
              <label
                className="form-check-label cursor-pointer"
                htmlFor={`term-${12 + index}`}
              >
                {term}
              </label>
            </div>
          ))}
        </div>
      </div>
      <div className="mt-3 d-flex flex-column gap-2">
        <p>
          That I have read and fully understood the rules and regulations of the
          COMPANY and I promise to abide and adhere to all conditions stated
          therein.
        </p>
        <p>
          Should I in any way commit infractions with respect to the Rules and
          Regulations of LGS STAFF MANAGEMENT SERVICES INCORPORATED, I am aware
          that I shall be subjected to sanctions as specified therein.{" "}
        </p>
        <p>
          I am hereby affixing my signature on this document this <u>{day}</u>{" "}
          day of{" "}
          <u>
            {month} 20{String(year).slice(2)}
          </u>{" "}
          in my own free will and without coercion.
        </p>
      </div>

      <div className="mt-3 d-flex justify-content-start">
        <div className="d-flex flex-column text-center col-lg-5">
          {signature && (
            <div className="mt-3">
              <img
                src={signature}
                alt="Signature Preview"
                className="img-thumbnail"
                style={{ maxWidth: "200px" }}
              />
            </div>
          )}
          <u>
            {" "}
            {fullname.toUpperCase()} {formattedDate}
          </u>
          <p>Staff Signature over printed name/Date</p>
        </div>
      </div>
      <div className="d-flex flex-column text-center">
        <p>Please let us know if you have any questions or clarifications.</p>
        <div className="d-flex flex-column">
          <b>LGS STAFF MANAGEMENT SERVERICES INC.</b>
          <b>
            Office Address: LGS Centre, 1639 Dian corner, Rockefeller St. Brgy.
            San Isidro, Makati City
          </b>
          <b>Tel: (632) 8889-2680</b>
        </div>
      </div>
      <div className="d-flex justify-content-end">
        <div className="d-flex flex-column">
          <p>Orientation conducted by:</p>
          <div className="border border-black border-bottom mt-4"></div>
          <p>Signature over printed name</p>
        </div>
      </div>

      <div className="mb-4 d-flex flex-column">
        {/* <label className="form-label fw-semibold">Upload E-Signature:</label>
        <div>
          <InputFactory
            type="InputCamera"
            noCamera={true}
            saveImage={saveImageUseCase()}
            saveFile={saveFileUseCase()}
            onChange={handleSignatureChange}
            field="image1"
            required
          />
        </div> */}
      </div>

      {!agreedStatus && (
        <button
          onClick={handleSave}
          className="btn text-white col-lg-2"
          style={{ backgroundColor: `#d18237` }}
          // disabled={agreedStatus}
        >
          Save
        </button>
      )}

      {agreedStatus && (
        <div className="mt-3 alert alert-success" role="alert">
          ✅ All terms agreed.
        </div>
      )}
    </div>
  );
};

export default OrientationAgreement;
